// Yeni gelen mesaj tespiti: cihaz saati yerine gorulen mesaj id kumesi ile karsilastirilir.
function messageKey(m) {
    if (!m) return null;
    if (m.raw && (m.raw.uniqMessageId || m.raw._id)) return String(m.raw.uniqMessageId || m.raw._id);
    return m.id ? String(m.id) : null;
}
// Kumede olmayan, karsi taraftan gelen ve sistem olmayan mesajlar
function pickNewIncoming(list, seen) {
    return (list || []).filter((m) => {
        const k = messageKey(m);
        if (!k || (seen && seen.has(k))) return false;
        return m.author !== "me" && m.type !== "system";
    });
}
// Verilen listedeki tum anahtarlari "gorulmus" say
function absorbKeys(list, seen) {
    (list || []).forEach((m) => { const k = messageKey(m); if (k) seen.add(k); });
    return seen;
}
module.exports = { messageKey, pickNewIncoming, absorbKeys };



// WEBPACK FOOTER //
// ./src/utils/shell/newMessages.js